import { times } from "lodash";
import {
  Row,
  RowContainer,
} from "@circle-react-uikit/SkeletonLoader/components";

export interface CommunitySidebarProps {
  count?: number;
}

export const CommunitySidebar = ({ count = 3 }: CommunitySidebarProps) => (
  <div className="skeleton-loader skeleton-loader--community-sidebar">
    <div className="skeleton-loader--community-sidebar__header">
      <Row xl long />
    </div>
    {times(count, index => (
      <div key={index} className="skeleton-loader--community-sidebar__item">
        <RowContainer xl>
          <Row half lg />
          <Row almostFull />
          <Row almostFull />
          <Row almostFull />
        </RowContainer>
      </div>
    ))}
  </div>
);
